<div class="quick__quote__container" #quickQuote>

  <!-- Spinner Container -->
  @if (showSpinner) {
    <div class="spinner__container">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  <!-- Questions Container -->
  @if (!showError && !showSpinner) {
    <div class="question__container">
      <div class="row">
        <div class="col-5 col-md-12 col-sm-12">
          @if (hasLeftPanelLoaded) {
            <app-csb-left-panel
              [header]="leftPanel.header"
              [content]="leftPanel.content"
              [footer]="leftPanel.footer"
            [url]="leftPanel.url"></app-csb-left-panel>
          }
        </div>
        <div class="col-7 col-md-12 col-sm-12">
          @if (hasQuestionLoaded) {
            <app-csb-question
              [question]="quoteStep.questionData"
            (updateStore)="handleStore( $event )"></app-csb-question>
          }
        </div>
      </div>
      @if (firstTimeHide) {
        <div class="row question__container__bottom">
          <div class="col-6 col-md-6 col-sm-12 question__container__bottom__label__container">
            <label class="question__container__bottom__label__container__label">Explore what businesses like you pay</label>
          </div>
          <div class="col-6 col-md-6 col-sm-12 question__container__bottom__button__container">
            @if (showEmailComponent) {
              <app-email
                [showLabel]="false"
                placeHolder="Email address"
              (next)="emailHandler($event)"></app-email>
            }
            <button
              class="question__container__bottom__button__container__continue background_border_gh"
              (click)="continue(quickQuote)"
            [disabled]="enableSubmit()">Submit</button>
          </div>
        </div>
      }
    </div>
  }

  <!-- Referral message for no products -->
  @if (showError && !showSpinner) {
    <div class="noProducts">
      <app-referral-message
        [isRetrieveQuote]="false"
      ></app-referral-message>
    </div>
  }

</div>
